import { render, staticRenderFns } from "./PPanel.vue?vue&type=template&id=efc3df2e"
import script from "./PPanel.vue?vue&type=script&lang=js"
export * from "./PPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports